import React from 'react';
import { Formik, Form } from 'formik';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import PasswordField from 'shared/components/password-field/PasswordField';
import Button from 'shared/components/button/Button';
import { setPasswordSchema } from 'utils/validators/setPassword';
import { setNewPassword, checkValidCode } from '../../ducks/actionsAuthActions';
import InvalidAction from '../InvalidAction/InvalidAction';
import './Activation.scss';

class ActivationForm extends React.Component {
  componentDidMount() {
    this.props.validInvitation(this.props.code, this.props.type);
  }

  render() {
    const {
      code,
      type,
      name,
      passwordUpdated,
      invalidInvitation,
      loading
    } = this.props;

    if (loading) {
      return <Loader />;
    }

    if (passwordUpdated) {
      return <Redirect to={`/get-started?name=${name}&type=${type}`} />;
    }

    if (invalidInvitation) {
      return (
        <InvalidAction
          title="Invalid Invitation"
          description="Your invitation is invalid or has expired!"
        />
      );
    }

    return (
      <Formik
        validationSchema={setPasswordSchema}
        initialValues={{ password: '', confirmPassword: '' }}
        onSubmit={values => {
          return this.props.setPassword(code, values.password, type);
        }}
      >
        {({ isSubmitting, values, errors }) => (
          <Form>
            <div className="activation-page">
              <div className="activation-content">
                <div className="form-content">
                  <h3>Welcome to your fitness journey.</h3>
                  <p>Choose a password to activate your account.</p>
                  <PasswordField name="password" />
                  <PasswordField
                    name="confirmPassword"
                    label="Confirm Password"
                  />
                  <label
                    className={`password-check form-check-label ${
                      values['password'].length === 0 || errors['password']
                        ? ''
                        : 'active'
                    }`}
                  >
                    <i className="fas fa-check-square"></i>
                    <span>At least 6 characters long</span>
                  </label>
                </div>
                <div className="form-action">
                  <Button
                    id=""
                    type="submit"
                    btnBlock="block"
                    color="primary"
                    label="Activate Account"
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    passwordUpdated: state.actionsReducer.passwordUpdated,
    invalidInvitation: state.actionsReducer.invalidCode,
    loading: state.actionsReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setPassword: (code, newPassword, type) =>
      dispatch(setNewPassword(code, newPassword, type)),
    validInvitation: (code, type) => dispatch(checkValidCode(code, type))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivationForm);
